/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

    addItem({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post("/API/Auth/AddUser", item)
                .then((response) => {
                    commit('ADD_ITEM', Object.assign(item, { Id: response.data.Id }))
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchDataListItems({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/API/Auth/GetAllUsers"
             , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
            )
                .then((response) => {
                    commit('SET_USERS', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    GetAllRoles({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/API/Auth/GetAllRoles")
                .then((response) => {
                    commit('SET_ROLES', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },


   updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.post("/API/Auth/UpdateUser", item)
            .then((response) => {
                
                commit('UPDATE_USER', response.data.Data) 
                resolve(response)
            })
            .catch((error) => { reject(error) })
    })
},

    UpdatePassword(context, item) {
        return new Promise((resolve, reject) => {
            axios.post("/API/Auth/UpdatePassword", item)
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    SendCode(context, email) {
        return new Promise((resolve, reject) => {
          
            axios.post("/API/Auth/SendOTP?email=" + email)
                .then((response) => {
                  
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    UpdatePassword(context, item) {
        return new Promise((resolve, reject) => {
            axios.post("/API/Auth/UpdatePassword", item)
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    VerifyCodeForConfirmEmail(context, item) {
        
        return new Promise((resolve, reject) => {
            axios.get("VerifyCodeForConfirmEmail", {
                    params: {
                        email: item.Email,
                        code: item.Code
                    }

                })
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

 removeUser({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.put("/API/Auth/DeleteUser?ID=" + item)
            .then((response) => {
                commit('REMOVE_ITEM', item)
                resolve(response)
            })
            .catch((error) => { reject(error) })
    })
},
   approveUser(context, userId) {
    return new Promise((resolve, reject) => {

       axios.put(`/API/Auth/ApproveUser/${userId}`)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => { reject(error) })
    })
},

}
